import { cn } from '@/shadcn/lib/utils.ts'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        secondaryBezel:
          'text-white bg-linear-to-b from-gray-500 to-gray-600 ring-1 ring-gray-600 bezel hover:from-gray-600 hover:to-gray-700 hover:ring-gray-700 transition-all',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        indigo: 'border-transparent bg-indigo-500 hover:bg-indigo-400 text-white',
        indigoBezel: 'border-transparent bg-indigo-500 hover:bg-indigo-400 text-white bezel-xs',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
